import React, { memo } from "react";
import NumberFormat from "react-number-format";
import LabeledInput, {
  CommonLabeledInputProps,
  CommonLabeledInputElementProps,
} from "../labeledInput";

export interface LabeledMaskInputProps
  extends CommonLabeledInputElementProps,
    CommonLabeledInputProps,
    React.HTMLProps<HTMLInputElement> {
  allowNegative: boolean;
  onValueChange: (value: string) => void;
  format: string;
  allowEmptyFormatting?: boolean;
}

export interface NumberFormatValues {
  floatValue: number | undefined;
  formattedValue: string;
  value: string;
}

const LabeledMaskInput: React.FC<LabeledMaskInputProps> = memo(({
  label,
  required,
  labelMode,
  requiredAsteriskDisabled,
  meta,
  error,
  className,
  ...props
}) => {
  const isFailed = (): boolean => {
    return (meta?.touched && meta?.error) || error ? true : false;
  };

  return (
    <LabeledInput
      label={label}
      labelMode={labelMode}
      required={required}
      requiredAsteriskDisabled={requiredAsteriskDisabled}
      isFailed={isFailed}
      error={meta?.error || error}
      className={className || ''}
    >
      <div className="xgs-input">
        <NumberFormat
          allowNegative={props.allowNegative}
          allowEmptyFormatting={props.allowEmptyFormatting !== undefined ? props.allowEmptyFormatting : true}
          placeholder={props.placeholder || ""}
          isNumericString={true}
          thousandSeparator={false}
          format={props.format}
          className={`xgs-input__field ${isFailed() ? "not-valid" : ""}`}
          value={`${props.value}`}
          onValueChange={(valuesObj: NumberFormatValues) => props.onValueChange(valuesObj.value)}
          onKeyDown={(e) => {
            props.onKeyDown && props.onKeyDown(e);
          }}
        />
      </div>
    </LabeledInput>
  );
});

export default LabeledMaskInput;
